var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { WorkplaceServiceRequestProvider, useWorkplaceServiceRequestContext, } from './context/WorkplaceServiceRequestContext';
import { Iframe } from './components/Iframe';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@robinpowered/ui-kit';
import { AddSectionButton } from '../../common/AddSectionButton';
var WorkplaceServiceRequestContainer = function (_a) {
    var currentUserCanRequestServices = _a.currentUserCanRequestServices;
    var t = useTranslation('workplaceService').t;
    var _b = useWorkplaceServiceRequestContext(), serviceRequestFormStatus = _b.serviceRequestFormStatus, onAddWorkplaceServiceRequest = _b.onAddWorkplaceServiceRequest, onCloseIframe = _b.onCloseIframe, onSubmitIframe = _b.onSubmitIframe;
    return (_jsxs(_Fragment, { children: [!!serviceRequestFormStatus && (_jsx(Iframe, { onClose: onCloseIframe, onSubmit: onSubmitIframe })), _jsx(Tooltip, { title: !currentUserCanRequestServices ? t("button.no_permission") : undefined, children: _jsx(AddSectionButton, { label: t('button.label'), disabled: !currentUserCanRequestServices, onClick: onAddWorkplaceServiceRequest }) })] }));
};
export var WorkplaceServiceRequest = function (_a) {
    var onSuccessfulRequest = _a.onSuccessfulRequest, props = __rest(_a, ["onSuccessfulRequest"]);
    return (_jsx(WorkplaceServiceRequestProvider, __assign({ onSuccessfulRequest: onSuccessfulRequest }, props, { children: _jsx(WorkplaceServiceRequestContainer, { currentUserCanRequestServices: props.currentUserCanRequestServices }) })));
};
